module.exports = __webpack_public_path__ + "static/media/test5_2.f826f583.png";